export default __webpack_public_path__ + "static/media/template-arrendamiento.561ee7d6.jpg";